import { Popover } from 'antd';

export const AntPopover = Popover;
